import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../keycloak/services/auth.service';
import { environment } from '../../../../environments/environment';
import { StorageUtils } from '../utils/StorageUtils';

export const authGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // 1. Si ya hay cuenta activa, pasamos
  if (authService.activeAccount()) {
    return true;
  }

  // 2. No hay sesión: guardamos a dónde quería ir el usuario y lo mandamos a /login
  // para que dispare explícitamente el login con Keycloak (no hay SSO silencioso
  // con un IdP orientado a cliente final).
  StorageUtils.set(StorageUtils.STATE_KEY, state.url);

  return router.parseUrl(environment.auth_environment.REDIRECT_GUARD_RUTE);
};